export enum FeatureStatus {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED'
}
